export enum SubmissionsSortField {
    Description = 'description',
    LastUpdated = 'lastUpdated',
    Submitted = 'submitted',
    FollowUpDueDate = 'followUpDueDate',
    Manager = 'manager'
}
